<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">KING JAMES VI &amp; I</h1>
<h1 class="titlea">THE KING WHO UNITED SCOTLAND AND ENGLAND</h1>
<p class="author">KEITH COLEMAN</p>
<div class="image_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?c382329e